import {CounterInput, Flex, Text} from '@priority-software/priority-style-react';
import React, {useEffect} from 'react';
import {useState} from 'react';
import styles from './styles.module.scss';

interface quantitySelectorProps {
    onCheckBoxChange: (e: any) => void;
    isChecked: boolean;
    partQuant: number;
    onQuantChange: (value: number) => void;
    partUnitName: string;
}

const QuantitySelector = (props: quantitySelectorProps) => {
    const {onCheckBoxChange, isChecked, partQuant, onQuantChange, partUnitName} = props;
    const [quant, setQuant] = useState(partQuant);

    useEffect(() => {
        setQuant(partQuant);
    }, [partQuant]);

    const dynamicStyle = {
        width: `${(quant.toString().length > 10 ? 10 : quant.toString().length) * 15 + 100}px`
    };

    const handleInputChange = (val: number) => {
        if ((isChecked && !val) || (!isChecked && val)) {
            onCheckBoxChange(new Event(this));
        }
        setQuant(val);
        onQuantChange(val);
    };

    return (
        <>
            <Flex
                direction="row"
                justifyContent="flex-start"
                style={dynamicStyle}
                onClick={e => e.stopPropagation()}
            >
                <CounterInput
                    componentClasses={styles.quantSelector}
                    step={1}
                    minValue={0}
                    onChange={handleInputChange}
                    value={quant}
                />
                <Text
                    componentClasses={styles.quantSelectorUnitName}
                    children={`/${partUnitName}`}
                    skin="paragraph-2"
                    textColor="secondary-500"
                />
            </Flex>
        </>
    );
};

export default QuantitySelector;
